import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption } from '@fleet-beat/core';
import { CombinedMalfunctionOptions } from '../enums/logbook';
import { LogbookRecordMalfunction } from '@fleet-beat/api';

@Pipe({
  name: 'malfunctionLabelPipe',
})
export class MalfunctionLabelPipe implements PipeTransform {
  transform(value: LogbookRecordMalfunction): string | null {
    if (!value) return null;
    return CombinedMalfunctionOptions.find((item: SelectOption) => value.code === item.value).label;
  }
}
